import React, { useState } from "react";
import "./Header.css";
import thereLogo from "../assets/images/there-logo.png";
import thereLandscape from "../assets/images/there-still.png";
import IconWrapper from "../components/IconWrapper";
import VideoModal from "../components/VideoModal";
import socialLinks from "../config/socialLinks";
import useDevice from "../hooks/useDevice";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDesktop } = useDevice();
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <header
      className="header"
      style={{ backgroundImage: `url(${thereLandscape})` }}
    >
      <nav className="header__nav">
        <div className="header__title">
          <img src={thereLogo} alt="Logo" className="header__logo" />
          <div className="header__description">
            un court-métrage en post-production
          </div>
        </div>

        <div className="header__cta">
          {isDesktop ? (
            <button className="header__btn" onClick={() => setIsOpen(true)}>
              Nous rejoindre
            </button>
          ) : (
            <button
              onClick={() => {
                // display social links
              }}
              className="header__icon"
              aria-label="Social Link"
            >
              <IconWrapper
                iconName="logo"
                className="header__icon-svg"
                width={40}
                height={40}
              />
            </button>
          )}

          <div className={`header__icons${isDesktop ? "" : " hidden"}`}>
            {socialLinks.map(({ name, url, icon, size }) => (
              <button
                key={name}
                onClick={() => openInNewTab(url)}
                className="header__icon"
                aria-label={name}
              >
                <IconWrapper
                  iconName={icon}
                  className="header__icon-svg"
                  width={size || 28}
                  height={size || 28}
                />
              </button>
            ))}
          </div>
        </div>
      </nav>

      <div className="header__play" onClick={() => setIsOpen(true)}>
        <IconWrapper iconName="play" className="header__play-icon" />
        <span className="header__play-text">Trailer</span>
      </div>

      <VideoModal
        videoId="m_2RMDDg0bM"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </header>
  );
};

export default Header;
